// An organisation with one active branch (NCS) does not need branch pickers: forms fill the branch in and hide the field.
export function onlyBranch(branches) {
  return Array.isArray(branches) && branches.length === 1 ? branches[0] : null;
}
